export const SALES_TAXES_REDUCER_KEY = 'salesTaxesStore';
export type SALES_TAXES_REDUCER_KEY = typeof SALES_TAXES_REDUCER_KEY;

import z from 'zod';
import type { QcsResourceSlice } from '../core/resourceSliceUtils';

export const SalesTaxSchema = z
  .object({
    id: z.string(),
    clientId: z.string(),
    name: z.string(),
    rate: z.number(),
    isShippingTaxable: z.boolean(),
    createdAt: z.string(),
    modifiedAt: z.string(),
    isDeleted: z.boolean(),
  })
  .partial();

export type SalesTaxType = z.infer<typeof SalesTaxSchema>;
export type SalesTaxesState = QcsResourceSlice<SalesTaxType>;

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [SALES_TAXES_REDUCER_KEY]: SalesTaxesState;
  }
}
